import { render } from "./ComicstripView.vue?vue&type=template&id=7884fb3a"
import script from "./ComicstripView.vue?vue&type=script&lang=js"
export * from "./ComicstripView.vue?vue&type=script&lang=js"

import exportComponent from "/media/shared/vue/comicviewer-with-router/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__